const PARTNERS = [
    { name: "Allianz-Țiriac", src: "/insurers/allianz-tiriac.png" },
    { name: "Groupama", src: "/insurers/groupama.png" },
    { name: "Omniasig VIG", src: "/insurers/omniasig.png" },
    { name: "Generali", src: "/insurers/generali.svg" },
    { name: "Asirom VIG", src: "/insurers/asirom.png" },
    { name: "Grawe", src: "/insurers/grawe.svg" },
    { name: "Axeria IARD", src: "/insurers/axeria.png" },
    { name: "Hellas Direct", src: "/insurers/hellas-direct.png" },
    { name: "Eazy Asigurări", src: "/insurers/eazy.png" },
    { name: "NN", src: "/insurers/nn.svg" },
    { name: "Signal Iduna", src: "/insurers/signal-iduna.svg" },
];

export default function Partners() {
    return (
        <section data-testid="partners-section" className="bg-white border-y border-[#0d3d2e]/10 py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="text-center mb-10">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#0d3d2e]/60 mb-3">
                        Asigurători parteneri
                    </div>
                    <h3 className="font-display text-3xl sm:text-4xl text-[#0d3d2e]">
                        Comparăm ofertele celor mai importanți asigurători
                    </h3>
                </div>
                <div className="flex flex-wrap justify-center items-stretch gap-3 lg:gap-4">
                    {PARTNERS.map((p) => (
                        <div
                            key={p.name}
                            data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="group flex items-center justify-center px-7 py-5 bg-[#fcfbf8] border border-[#0d3d2e]/10 rounded-xl hover:border-[#0d3d2e]/30 hover:translate-y-[-2px] transition-all"
                        >
                            <img
                                src={p.src}
                                alt={p.name}
                                title={p.name}
                                loading="lazy"
                                className="h-8 lg:h-10 w-auto max-w-[160px] object-contain"
                            />
                        </div>
                    ))}
                </div>
                <p className="text-center text-sm text-[#1a1a1a]/55 mt-8">
                    ...și alte 10+ companii de asigurări, bănci și IFN-uri partenere prin rețeaua Safety Broker.
                </p>
            </div>
        </section>
    );
}
